import { All_NOTIFICATIONS } from '../actions/actionTypes';

let user = localStorage.getItem('userDetails');
const initialState = user ? { loggedIn: true,notifications:[]} : {notifications:[]};

export default function notifications(state = initialState, action) {
    switch (action.type) {
        case All_NOTIFICATIONS:
            return {
                ...state, 
                notifications:action.notifications
                
            };
        default:
            return state
    }
}